import './BookingInformation.scss';
import { Dispatch, SetStateAction } from 'react';
import { Field } from '../../models/home';
import { handleOnBlur } from '../../helpers/form';
import { useBookingInformation } from './useBookingInformation';
import { VALIDATION_TYPE } from '../../constants/common';
import AppText from '../AppCommon/AppText/AppText';

interface Props {
    fields: Field[];
    setFields: Dispatch<SetStateAction<Field[]>>;
    setCompensationFields: Dispatch<SetStateAction<Field[]>>;
}

const BookingInformation = ({fields, setFields, setCompensationFields}: Props) => {
    const { handleOnChangeTextBI, t } = useBookingInformation({ setFields, setCompensationFields });

    return (
        <div className="c-booking-info">
            <AppText
                label={t('labels.bookingReference')}
                width={100}
                error={fields[0].error || fields[0].requiredError ? true : false}
                helperText={fields[0].error || fields[0].requiredError}
                maxLength={6}
                value={fields[0].value}
                onBlur={e => handleOnBlur(e, 0, 6, t('validations.bookingReference'), setFields)}
                onChange={e => {
                    handleOnChangeTextBI(
                        e,
                        fields[0].name,
                        0,
                        1,
                        VALIDATION_TYPE.alphaNumeric,
                    )}
                }
            />
            <label className="label">{t('labels.or')}</label>
            <AppText
                label={t('labels.ticketNum')}
                width={100}
                error={fields[1].error || fields[1].requiredError ? true : false}
                helperText={fields[1].error || fields[1].requiredError}
                maxLength={13}
                value={fields[1].value}
                onBlur={e => handleOnBlur(e, 1, 13, t('validations.ticketNumberMin'), setFields)}
                onChange={e => {
                    handleOnChangeTextBI(
                        e,
                        fields[1].name,
                        1,
                        0,
                        VALIDATION_TYPE.alphaNumeric,
                    )}
                }
            />
        </div>
    );
};

export default BookingInformation;